import styles from './page-header.module.css';

type PageHeaderProps = {
  title: string;
};

/** The first row of every top-level screen: one title, one place, one size. */
export const PageHeader = ({ title }: PageHeaderProps) => (
  <header className={styles.header}>
    <h1 className={styles.title}>{title}</h1>
  </header>
);
